<template>
    <FormBox header="Angaben zum Titel">
        <!-- Sammelwerk select (only for type 2 = Beitrag) -->
        <div v-show="currentType == PublicationType.Sammelwerksbeitrag">
            <FormSelect
                v-model="form.publication"
                :options="payload.sammelwerke"
                option-value="uid"
                option-label="title"
                label="Sammelwerk"
                tooltip="publication"
                placeholder="Sammelwerk auswählen"
                :required="currentType == PublicationType.Sammelwerksbeitrag"
            />
        </div>

        <!-- Title with duplicate check -->
        <FormField
            v-model="form.title"
            label="Hauptsachtitel"
            tooltip="title"
            placeholder="Titel eingeben"
            :required="true"
            @input="onTitleInput"
        >
            <template #after>
                <SimilarTitles
                    v-if="isNew"
                    :value="form.title"
                    :check-url="checkTitleUrl"
                    :confirm-modal="confirmModal"
                    header="Es gibt Artikel mit ähnlichem Titel:"
                />
            </template>
        </FormField>

        <FormField
            v-model="form.subtitle"
            label="Untertitel"
            tooltip="subtitle"
            placeholder="Untertitel eingeben"
            :highlight="true"
        />

        <div class="row">
            <div class="col-12 col-lg-6">
                <FormField
                    v-model="form.parallelTitle"
                    label="Paralleltitel"
                    tooltip="parallelTitle"
                    placeholder="Paralleltitel eingeben"
                />
            </div>
            <div class="col-12 col-lg-6">
                <FormField
                    v-model="form.favor"
                    label="Gefälligkeitsübersetzung des Titels"
                    tooltip="favor"
                    placeholder="Gefälligkeitsübersetzung des Titels eingeben"
                />
            </div>
            <div class="col-12 col-lg-6">
                <FormField
                    v-model="form.uniformTitle"
                    label="Einheitssachtitel"
                    tooltip="uniformTitle"
                    placeholder="Einheitssachtitel eingeben"
                />
            </div>
            <div class="col-12 col-lg-6">
                <FormField
                    v-model="form.secondaryTitle"
                    label="Umschlagtitel / Nebentitel"
                    tooltip="secondaryTitle"
                    placeholder="Umschlagtitel / Nebentitel eingeben"
                />
            </div>
            <div class="col-12 col-lg-12">
                <FormField
                    v-model="form.otherTitle"
                    label="Titel in anderen Sprachen"
                    tooltip="otherTitle"
                    placeholder="Titel in anderen Sprachen eingeben"
                />
            </div>
        </div>

        <!-- Series + Volume (only for Monographie/Sammelwerk — hidden for Beitrag and Zeitschrift) -->
        <div class="row" v-show="currentType != PublicationType.Zeitschriftenaufsatz && currentType != PublicationType.Sammelwerksbeitrag">
            <div class="col-12 col-lg-6">
                <FormSelect
                    v-model="form.series"
                    :options="payload.series"
                    option-value="uid"
                    option-label="title"
                    label="Reihentitel"
                    tooltip="series"
                    placeholder="Reihentitel auswählen"
                    :can-create="true"
                />
            </div>
            <div class="col-12 col-lg-6">
                <FormField
                    v-model="form.volume"
                    label="Bandnummer"
                    tooltip="volume"
                    placeholder="Bandnummer eingeben"
                    type="number"
                    :min="0"
                    :step="1"
                />
            </div>
        </div>

        <!-- Magazine fields (only for type 3) -->
        <div v-show="currentType == PublicationType.Zeitschriftenaufsatz">
            <FormSelect
                v-model="form.magazine"
                :options="payload.magazines"
                option-value="uid"
                option-label="title"
                label="Zeitschriftentitel"
                tooltip="magazine"
                placeholder="Zeitschrift auswählen"
                :required="currentType == PublicationType.Zeitschriftenaufsatz"
                :can-create="true"
            />
            <div class="row">
                <div class="col-12 col-lg-8">
                    <FormField
                        v-model="form.magazineBook"
                        label="Zeitschriftenheft"
                        tooltip="magazineBook"
                        placeholder="Zeitschriftenheft eingeben"
                        :recommended="currentType == PublicationType.Zeitschriftenaufsatz"
                    />
                </div>
                <div class="col-12 col-lg-4">
                    <FormField
                        v-model="form.magazineYear"
                        label="Zeitschriftenjahrgang"
                        tooltip="magazineYear"
                        placeholder="Zeitschriftenjahrgang eingeben"
                        :recommended="currentType == PublicationType.Zeitschriftenaufsatz"
                        type="number"
                        :min="0"
                        :step="1"
                    />
                </div>
            </div>
        </div>
    </FormBox>
</template>

<script setup>
import FormBox from './FormBox.vue';
import FormField from './FormField.vue';
import FormSelect from './FormSelect.vue';
import SimilarTitles from './SimilarTitles.vue';
import {PublicationType} from '../publicationTypes';

defineProps({
    form: { type: Object, required: true },
    currentType: { type: [Number, String], required: true },
    payload: { type: Object, required: true },
    checkTitleUrl: { type: String, default: '' },
    isNew: { type: Boolean, default: false },
    confirmModal: { type: Object, default: null },
});

function onTitleInput() {
    // Title input is handled reactively via v-model
}
</script>
